import { useState } from "react";
import "./LocationSection.css";

// 🔹 Controlled accordion block — open state now lives in the parent so only
// one block can be open across the whole group at a time.
function AccordionBlock({ emoji, title, items, open, onToggle }) {
  if (!title || !items?.length) return null;

  return (
    <div className={`location-accordion${open ? " open" : ""}`}>
      <button
        className="location-accordion__header"
        onClick={onToggle}
        aria-expanded={open}
      >
        <h4>{emoji} {title}</h4>
        <span className="location-accordion__icon">
          {open ? "−" : "+"}
        </span>
      </button>

      <div className="location-accordion__body">
        <div className="location-cards">
          {items.map((pt, i) => (
            <div key={i} className="location-card">
              <span className="location-card__pin">📍</span>
              <div className="location-card__info">
                <strong>{pt?.key}</strong>
                <span>{pt?.value}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function LocationSection({ location }) {

  // 🔹 Defaults to "key" ("Prime Location") open on load — only one of
  // "key" / "school" / "hospital" can be active at a time; opening
  // another closes whichever was previously open.
  const [activeSection, setActiveSection] = useState("key");

  const toggleSection = (name) =>
    setActiveSection((prev) => (prev === name ? null : name));

  // 🛑 CRITICAL FIX: prevent crash
  if (!location) return null;

  const {
    keyDistance,
    keyDistanceList,
    schoolDistanceTitle,
    schoolDistanceList,
    hospitalDistanceTitle,
    hospitalDistanceList,
    iframe
  } = location || {};

  const hasContent =
    keyDistance ||
    schoolDistanceTitle ||
    hospitalDistanceTitle;

  if (!hasContent && !iframe) return null;

  return (
    <section
      className="location-section section"
      id="location"
      aria-labelledby="location-heading"
    >
      <div className="container">
        <div className="location-section__grid">

          {/* Map */}
          {iframe && (
            <div className="location-map">
              <iframe
                src={iframe}
                title="Project location map"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          )}

          {/* Details */}
          <div className="location-details">

            <AccordionBlock
              emoji="💠"
              title={keyDistance}
              items={keyDistanceList}
              open={activeSection === "key"}
              onToggle={() => toggleSection("key")}
            />

            <AccordionBlock
              emoji="🎓"
              title={schoolDistanceTitle}
              items={schoolDistanceList}
              open={activeSection === "school"}
              onToggle={() => toggleSection("school")}
            />

            <AccordionBlock
              emoji="🏥"
              title={hospitalDistanceTitle}
              items={hospitalDistanceList}
              open={activeSection === "hospital"}
              onToggle={() => toggleSection("hospital")}
            />

          </div>
        </div>
      </div>
    </section>
  );
}
